import { Card, Link } from "@postenbring/hedwig-react";

// Keep in sync with src/main/resources/site/mixins/link-or-cta-group/index.es6 (TODO: find workaround for import)
export const LINKTYPE_INTERNAL = "internal";
export const LINKTYPE_EXTERNAL = "external";

export const BodyLink = ({ text, url, newTab, type, inverted, showAsInternal = false }) => (
  <Card.BodyAction asChild>
    <Link href={url} variant={inverted ? "inverted" : "solid"} target={newTab ? "_blank" : "_top"}>
      <Card.BodyActionArrow
        direction={type === LINKTYPE_EXTERNAL && !showAsInternal ? "up-right" : "right"}
        className={inverted ? "hds-link--inverted" : undefined}
      />
      {text}
    </Link>
  </Card.BodyAction>
);
